<fullscreen-page class="prepare-layout">
  <div class="prepare-left">
    <div class="prepare-header">
      <div class="prepare-title-row">
        <dx-button
          class="prepare-back-btn"
          icon="chevronleft"
          stylingMode="text"
          (onClick)="goBackToPrepareStage()"
        ></dx-button>

        <div class="prepare-title text-truncate">
          {{ catalogTitle }}
        </div>
      </div>

      <dx-tab-panel
        class="prepare-tabs"
        [dataSource]="tabItems"
        [selectedIndex]="selectedTabIndex"
        [animationEnabled]="true"
        [swipeEnabled]="false"
        [deferRendering]="false"
        (onSelectionChanged)="onTabSelectionChanged($event)"
      >
        <div *dxTemplate="let tab of 'title'">
          <span class="text-truncate">{{ tab.title }}</span>
        </div>

        <div *dxTemplate="let tab of 'item'"></div>
      </dx-tab-panel>
    </div>

    <div class="prepare-body">
      <catalog
        class="prepare-browse d-block h-100"
        [routeBasePath]="'/dataprocess/prepare-stage/catalog'"
        [customerIdOverride]="customerIdFromRoute"
        [catalogIdOverride]="catalogIdFromRoute"
        [additionalFilter]="additionalFilterForBrowseComponent"
      ></catalog>
    </div>
  </div>

  <div class="prepare-right-spacer" [class.right-hidden]="!isBrowseTab"></div>

  <help-column
    class="align-self-stretch {{ systemService.showHelp ? '' : 'd-none' }}"
    style="flex: 1 1;"
  ></help-column>
</fullscreen-page>
